import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import styles from './about.modules.sass'
import Link from 'next/link'

const AboutBlock = (props) => {
  const { type, about, editor, button } = props

  const [typeClass, setTypeClass] = useState('')
  const [editorTitle, setEditorTitle] = useState(`${type} Converter`)

  useEffect(() => {
    switch (type) {
      case 'Audio':
        setTypeClass(styles.audio_color)
        setEditorTitle('Audio Editor')
        break
      case 'Image':
        setTypeClass(styles.image_color)
        setEditorTitle('Image Compressor')
        break
      case 'Document':
        setTypeClass(styles.document_color)
        setEditorTitle('PDF Manager')
        break
      case 'Video':
        setTypeClass(styles.video_color)
        setEditorTitle('MP4 Online Converter')
        break
      case 'Presentation':
        setTypeClass(styles.document_color)
        break
      default:
        setTypeClass(styles.video_color)
    }
  }, [type])

  return (
    <section className={styles.about}>
      <div className='container'>
        <Row gutter={{ xs: 0, sm: 16, md: 24 }}>
          <Col xs={24} md={12} lg={12} xl={16}>
            <div className={styles.about_info}>
              <h3>{about.title}</h3>
              <span>{about.text}</span>
            </div>
          </Col>
          <Col xs={24} md={12} lg={12} xl={8}>
            <Row className={[styles.editor, typeClass].join(' ')} align='middle'>
              <Col xs={19} sm={21} md={18} lg={19} xl={17}>
                <h3>{editorTitle}</h3>
                <span>{editor.text}</span>
                <Link href={button.href}>
                  <a className={styles.link}>{button.text}</a>
                </Link>
              </Col>
              <Col xs={5} sm={3} md={6} lg={5} xl={7}>
                <img src={editor.icon} alt={editor.title} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default AboutBlock
